import type { MenuProps } from 'antd';
import { Menu, theme } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';

import { Icon } from '@/v1/main/views/Icon';
import { useAuth } from '@/v1/main/views/Provider';

import styles from './Navbar.module.scss';

export const Navbar: React.FC = () => {
    const { t } = useTranslation(['title']);
    const { sys } = useParams();
    const { pageId, menus } = useAuth();
    const [openKeys, setOpenKeys] = useState<string[]>([]);

    const onOpenChange: MenuProps['onOpenChange'] = (keys) => {
        const diff = keys.filter(
            (key) => !openKeys.includes(key) || key == 'rc-menu-more'
        );
        setOpenKeys(diff);
    };

    const items: MenuProps['items'] = menus.map((menu) => {
        const route_prefix = `/${sys}/${menu.programName}/`;
        const children = menu.children?.map((submenu) => {
            const route = route_prefix + submenu.programName;
            return {
                key: submenu.id,
                label: (
                    <Link to={route}>{t(submenu.name, { ns: 'title' })}</Link>
                ),
                icon: submenu.iconName ? (
                    <Icon className={styles.icon} value={submenu.iconName} />
                ) : undefined,
            };
        });

        return {
            key: menu.programName,
            label: t(menu.name, { ns: 'title' }),
            icon: menu.iconName ? (
                <Icon className={styles.icon} value={menu.iconName} />
            ) : undefined,
            children,
        };
    });
    const {
        token: { colorPrimary },
    } = theme.useToken();
    return (
        <div className={styles.wrapper}>
            <Menu
                mode="horizontal"
                selectedKeys={[pageId]}
                onOpenChange={onOpenChange}
                items={items}
                style={{
                    background: colorPrimary,
                }}
            />
        </div>
    );
};
